import { Section } from "./Section";
import { ARCHITECTURE } from "@/content/landing";

export function Architecture() {
  return (
    <Section
      id="architecture"
      testId="landing-architecture"
      eyebrow={ARCHITECTURE.eyebrow}
      title={ARCHITECTURE.title}
      subtitle={ARCHITECTURE.subtitle}
    >
      <div className="grid grid-cols-1 gap-x-10 gap-y-8 md:grid-cols-2">
        {ARCHITECTURE.pillars.map((p, i) => (
          <div
            key={p.title}
            data-testid={`landing-arch-pillar-${i}`}
            className="flex gap-5"
          >
            <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-border/60 bg-background font-mono text-xs text-accent">
              {String(i + 1).padStart(2, "0")}
            </div>
            <div>
              <h3 className="font-mono text-sm uppercase tracking-[0.18em] text-foreground">
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {p.body}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}
